module.exports = __webpack_public_path__ + "img/image_placeholder.0564aa69.png";